<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- eslint-disable vue/max-len max-len -->
    <path
      :class="classes"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.8586 8.71154C10.9189 8.86211 11.0096 8.99861 11.125 9.1125C11.35 9.35 11.65 9.4875 12 9.4875C12.3297 9.4828 12.6442 9.34802 12.875 9.1125C13.1125 8.8875 13.225 8.5875 13.225 8.2375C13.225 7.8875 13.1 7.6 12.875 7.3625C12.65 7.125 12.35 7.0125 12 7.0125C11.65 7.0125 11.3625 7.1375 11.125 7.3625C10.8875 7.5875 10.775 7.8875 10.775 8.2375C10.7699 8.39958 10.7984 8.56097 10.8586 8.71154ZM12.8625 11.125C13.1125 11.3875 13.225 11.675 13.25 11.9875V15.7375H13.5288C14.0593 15.7375 14.4971 16.2346 14.1125 16.6C13.85 16.85 13.5875 16.9875 13.25 16.9875H12C11.6625 16.9875 11.3875 16.85 11.1375 16.6C10.8875 16.3625 10.775 16.075 10.75 15.7375V11.9875H10.4685C9.93998 11.9875 9.5138 11.4987 9.8875 11.125C10.15 10.9 10.4125 10.7625 10.75 10.7375H12C12.3375 10.75 12.6125 10.8875 12.8625 11.125Z"
      fill="#ABACAC"
      fill-rule="evenodd"
    />
    <!-- eslint-enable vue/max-len max-len -->
  </svg>
</template>

<script
  lang="ts"
>
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SIconInfo',
  props: {
    color: {
      type: String,
    },
  },
  setup(props) {
    const classes = computed(() => [
      `s-icon-info_color-${props.color}`,
    ]);

    return {
      classes,
    };
  },
});
</script>

<style
  lang="scss"
  scoped
>
.s-icon-info {
  &_color-disabled {
    fill: var(--color-disabled);
  }

  &_color-danger {
    fill: var(--color-danger);
  }

  &_color-gray {
    fill: var(--color-gray);
  }

  &_color-linked {
    fill: var(--color-linked);
  }

  &_color-navigation {
    fill: var(--color-navigation);
  }

  &_color-primary {
    fill: var(--color-primary);
  }

  &_color-secondary {
    fill: var(--color-secondary);
  }

  &_color-success {
    fill: var(--color-success);
  }

  &_color-toolbar {
    fill: var(--color-toolbar);
  }

  &_color-warn {
    fill: var(--color-warn);
  }

  &_color-white {
    fill: var(--color-white);
  }

  &_color-black {
    fill: var(--color-black);
  }

  &_color-stroke {
    fill: var(--color-stroke);
  }
}
</style>
